<template>
    <div class="text-md-center">
        <v-container grid-list-md text-xs-center>
            <v-row v-if="token" class="mt-2">
                <v-col>
                    <v-col>
                        <v-icon class="red--text" light  size="100">warningt</v-icon>
                    </v-col>
                    <v-col>
                        <!--Paiement OK (Statut = 0)-->
                        <v-card v-if="satutPaiement == 0" class="pt-2">
                            {{$storeCandidature.langueFormulaire == 'en' ? 'Your payment is validated but your file has not been updated.' : 'Votre paiement est validé mais votre dossier n\'a pas été mis à jour.'}}
                            <br />
                            {{$storeCandidature.langueFormulaire == 'en' ? 'Please contact the school by providing the following information:' : 'Merci de contacter l\'école en communicant les informations suivantes :'}}
                            <br><br>
                            <div class="green--text">
                                <v-row no-gutters>
                                    <v-col align="right">
                                        {{$storeCandidature.langueFormulaire == 'en' ? 'Reference:' : 'Référence:'}}
                                    </v-col>
                                    <v-col align="left" class="ml-3">
                                        <h3>{{refPaiement}}</h3>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col align="right" class="pt-0">
                                        {{$storeCandidature.langueFormulaire == 'en' ? 'Status:' : 'Statut:'}}
                                    </v-col>
                                    <v-col align="left" class="ml-3">
                                        <h3>{{satutPaiement}}</h3>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col align="right">
                                        {{$storeCandidature.langueFormulaire == 'en' ? 'Time of operation:' : 'Heure de l\'opération:'}}
                                    </v-col>
                                    <v-col align="left" class="ml-3">
                                        <h3>{{heureOperation}}</h3>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-card>
                        <!--Paiement KO (Autre que 0, par exemple,la statut 17 pour paiement annuler)-->
                        <v-card v-else class="pt-2">
                            {{$storeCandidature.langueFormulaire == 'en' ? 'Your payment was not successful. Please start again from the application.' : 'Votre paiement n\'a pas abouti. Merci de recommencer à partir de la candidature.'}}

                        </v-card>
                    </v-col>
                </v-col>
            </v-row>
            <v-row v-else>
                <v-col>
                    {{$storeCandidature.langueFormulaire == 'en' ? 'URL ERROR' : 'Erreur URL'}}
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
    export default {
        name: 'er-paiment',

        data() {
            return {
                token: null,
                satutPaiement: 0,
                refPaiement: '',
                heureOperation: '',
            }
        },

        computed: {
        },

        methods: {

        },

        created() {
            // Détecter s'il y en a un param url pay
            if (this.$route.query.t) {
                // récupérer le token
                this.token = this.$route.query.t

                // Decoder le token pour récupérer le sinformation
                var tabInfo = this.$utils.b64_to_utf8(this.token).split('|')
                this.refPaiement = tabInfo[0]
                this.satutPaiement = tabInfo[1]
                this.heureOperation = tabInfo[2]

                // Maj l'url pour n'afficher que la racine
                this.$router.push("/erpai"); // ToDo : à activer
            }
        }
    }
</script>

